import { render, staticRenderFns } from "./EconomicGroup.vue?vue&type=template&id=1ab586d9"
import script from "./EconomicGroup.vue?vue&type=script&lang=js"
export * from "./EconomicGroup.vue?vue&type=script&lang=js"
import style0 from "./EconomicGroup.vue?vue&type=style&index=0&id=1ab586d9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports